<template>
    <div class="cz2__ai-modal__get-started">
        <div class="cz2__ai-modal__get-started__content">
            <div class="cz2__ai-modal__main">
                <red-banner-button as="div">
                    {{ $t('AI_SUPER_HEADING') }}
                </red-banner-button>

                <div class="cz2__modal-popup__header">
                    {{ $t('AI_HEADING') }}
                </div>

                <div class="cz2__modal-popup__copy">
                    <p>
                        {{ aiCopy }}
                    </p>
                </div>

                <div class="cz2__ai-modal__buttons">
                    <selfie-button />
                    <upload-button ref="uploadButton" />
                    <build-button />
                </div>
            </div>

            <div class="cz2__ai-modal__pops" />
        </div>

        <base-disclaimer :message-copy="privacyPolicy" />
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-modal {
            .cz2__ai-modal__get-started {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                gap: 16px;
                justify-content: space-between;
                padding: 40px 20px 20px 20px;

                .cz2__ai-modal__get-started__content {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                }

                .cz2__red-banner-button {
                    filter: none;
                    margin-left: -16px;
                    margin-bottom: 16px;
                    padding-right: 0;
                    width: fit-content;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    letter-spacing: 0;

                    &:before {
                        left: 0;
                    }
                }

                .cz2__modal-popup__header,
                .cz2__modal-popup__copy {
                    text-align: center;
                }

                .cz2__modal-popup__copy {
                    margin-top: 8px;
                }

                .cz2__ai-modal__main {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .cz2__ai-modal__buttons {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                }
                .cz2__btn {
                    width: 100%;
                    height: 40px;
                    font-size: 18px;

                    &:hover {
                        font-size: 20px;
                    }
                }

                .cz2__ai-modal__pops {
                    flex-grow: 1;
                    background: url('../../assets/images/ai-pops.webp') no-repeat center/contain;
                }

                /* CSS rules for tablets in portrait orientation */
                @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
                    padding: 72px 50px;

                    .cz2__ai-modal__main {
                        width: auto !important;
                        max-width: 588px !important;
                        align-self: center;
                    }

                    .cz2__modal-popup__header {
                        font-size: 48px;
                        margin-bottom: 24px;
                    }
                    .cz2__red-banner-button__content,
                    .cz2__modal-popup__copy {
                        font-size: 18px;
                    }

                    .cz2__modal-popup__copy {
                        margin-bottom: 24px;
                    }

                    .cz2__ai-modal__buttons {
                        .cz2__btn {
                            height: 48px;
                        }
                    }

                    .cz2__ai-modal__get-started__content {
                        flex-direction: column !important;
                    }
                }

                @include respond-above(lg) {
                    padding: 48px 64px 24px 64px;

                    .cz2__ai-modal__get-started__content {
                        flex-direction: row;
                        gap: 70px;
                        align-items: center;
                    }

                    .cz2__red-banner-button {
                        margin-left: 0;
                        font-size: 18px;
                    }

                    .cz2__ai-modal__main {
                        width: 365px;
                        align-items: flex-start;
                    }

                    .cz2__modal-popup__header,
                    .cz2__modal-popup__copy {
                        text-align: left;
                    }

                    .cz2__ai-modal__buttons {
                        margin-top: 24px;
                    }

                    .cz2__btn {
                        height: 48px;
                    }

                    .cz2__ai-modal__pops {
                        align-self: stretch;
                    }
                }
            }
        }
    }
</style>

<script>
    import RedBannerButton from '../RedBannerButton.vue';
    import SelfieButton from './SelfieButton.vue';
    import UploadButton from './UploadButton.vue';
    import BuildButton from './BuildButton.vue';
    import BaseDisclaimer from './BaseDisclaimer.vue';

    export default {
        components: {
            RedBannerButton,
            SelfieButton,
            UploadButton,
            BuildButton,
            BaseDisclaimer,
        },

        computed: {
            launchedFromSwitchModal() {
                return this.$store.state.launchedFromSwitchModal;
            },

            privacyPolicy() {
                return this.$t('AI_POLICY').replace('{policyLink}', this.$t('AI_POLICY_LINK'));
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            isFirstPop() {
                return this.$store.state.customizer.viewController === this.$store.getters.popControllers[0];
            },

            aiCopy() {
                let copy = this.$t('AI_COPY');

                if (this.isTwoPack) {
                    if (this.isFirstPop) {
                        copy = this.$t('AI_COPY_POP_ONE');
                    } else {
                        copy = this.$t('AI_COPY_POP_TWO');
                    }
                }

                return copy;
            },
        },

        mounted() {
            if (this.launchedFromSwitchModal) {
                this.$refs.uploadButton.$el.click();
                this.$store.dispatch('setLaunchedFromSwitchModal', false);
            }
        },
    };
</script>
